import React, { useContext, useEffect, useState } from 'react';
import { Icon } from 'office-ui-fabric-react';

import { Props } from './ControllerTask.types';
import { Styled } from './ControllerTask.styles';
import { useHistory, useRouteMatch } from 'react-router';
import { PageHeader } from '../components/PageHeader';
import moment from 'moment';
import { dateFormats, formatMinutes } from 'utils/dateFormats';
import { bcContext } from '../context';
import { Page } from '../components/Page';
import { BackButton } from '../components/NavigationButton';

export const ControllerTask: React.FC<Props> = () => {
  const { task } = useContext(bcContext);

  const history = useHistory();

  if (!task) return null;

  const onClick = () => {
    history.push('/bc/departmentcontroll?dep_id=' + task.department_id);
  };

  return (
    <Page
      title={`Наряд задание №${task.id}`}
      primaryButtonNode={<BackButton onClick={() => history.goBack()} />}
    >
      <Styled.PageWrapper>
        <Styled.DataRow>
          <p>Дата</p>
          {moment(task.date).format(dateFormats.readableDate)}
        </Styled.DataRow>
        <Styled.DataRow>
          <p>Часы работы</p>
          <p>
            {formatMinutes(task.graphicType_start)} -
            {formatMinutes(task.graphicType_end)}
          </p>
        </Styled.DataRow>
        <Styled.DataRow tabIndex={1} onClick={onClick}>
          <span>Район контроля</span> <Icon iconName="MapPin" />
        </Styled.DataRow>
        <Styled.DataRow>
          <p>ФИО Сотрудников</p>
          {task.workers.map(({ fio }) => (
            <div key={fio}>{fio}</div>
          ))}
        </Styled.DataRow>
        <Styled.DataRow>
          <p>Основные проверяемые маршруты</p>
          {task.routes
            .filter(({ type }) => type === 0)
            .map(({ short_name }) => (
              <div key={short_name}>{short_name}</div>
            ))}
        </Styled.DataRow>
        <Styled.DataRow>
          <p>Попутно проверяемые маршруты</p>
          {task.routes
            .filter(({ type }) => type === 1)
            .map(({ short_name }) => (
              <div key={short_name}>{short_name}</div>
            ))}
        </Styled.DataRow>
      </Styled.PageWrapper>
    </Page>
  );
};
